// Auto-regenerated from finance Google Sheet on 25 Feb 2026.
// Source: https://docs.google.com/spreadsheets/d/1OrzN7GdZOrEojykK4txzbm2NSm3HAiwffSpIUrRaTMY/
// Amounts in ₹ Cr. Maintained manually by Finance.
export const UNDER_CLOSURE_DATA = [
  {
    "trust": "SDTT",
    "id": "70122",
    "req": "G-70122",
    "status": "Under Closure",
    "theme": "Building Institutions",
    "grantee": "Massachusetts Institute of Technology",
    "title": "Support to MIT for Tata Centre",
    "start": "01-Apr-2016",
    "end": "01-Mar-2021",
    "sanc": 187.0,
    "disb": 67.22,
    "bal": 119.78,
    "finBal": 119.78,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "70181",
    "req": "G-70181",
    "status": "Under Closure",
    "theme": "Building Institutions",
    "grantee": "University of California",
    "title": "Setting up Tata Institute for Active Genetics and Society 007",
    "start": "01-Apr-2016",
    "end": "31-Mar-2021",
    "sanc": 136.0,
    "disb": 49.11,
    "bal": 86.89,
    "finBal": 86.89,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70182",
    "req": "G-70182",
    "status": "Under Closure",
    "theme": "Building Institutions",
    "grantee": "University of California",
    "title": "Setting up Tata Institute for Active Genetics and Society.008",
    "start": "01-Oct-2016",
    "end": "30-Sep-2021",
    "sanc": 102.0,
    "disb": 40.49,
    "bal": 61.51,
    "finBal": 61.51,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "JRD Tata",
    "id": "70165",
    "req": "G-70165",
    "status": "Active",
    "theme": "Education",
    "grantee": "Tata Community Initiative Trust",
    "title": "GE-Skilling program for Healthcare Technicians (Phase II)",
    "start": "01-Nov-2020",
    "end": "31-Oct-2023",
    "sanc": 37.2,
    "disb": 6.58,
    "bal": 30.62,
    "finBal": 30.62,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "70163",
    "req": "G-70163",
    "status": "Active",
    "theme": "Education",
    "grantee": "Tata Community Initiative Trust",
    "title": "Dual Vocational & Educational Training (VET) Program for ITIs",
    "start": "01-Nov-2019",
    "end": "30-Sep-2023",
    "sanc": 11.61,
    "disb": 1.94,
    "bal": 9.68,
    "finBal": 9.68,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "70063",
    "req": "G-70063",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Dairy Health and Nutrition Initiative India Foundation",
    "title": "Sakhi Mahila Milk Producer Company Retail Marketing Plan",
    "start": "01-Oct-2023",
    "end": "30-Sep-2026",
    "sanc": 8.41,
    "disb": 2.26,
    "bal": 6.15,
    "finBal": 6.15,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "RDTT",
    "id": "2025-70514",
    "req": "G-2025-70514",
    "status": "Active",
    "theme": "Building Institutions",
    "grantee": "Indian Institute of Technology-Delhi",
    "title": "Phase 2: Enhancing India's Science and Technology Policy Analysis Capabilities",
    "start": "01-Mar-2025",
    "end": "28-Feb-2030",
    "sanc": 20.0,
    "disb": 1.97,
    "bal": 18.02,
    "finBal": 4.55,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70055",
    "req": "G-70055",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "Collectives for Integrated Livelihood Initiatives",
    "title": "Climate Smart Agriculture and Livestock (CSAL) program in 3 agrarian, distressed districts - Akola, Amravati and Yavatmal of Vidarbha, Maharashtra",
    "start": "01-Apr-2023",
    "end": "31-Oct-2024",
    "sanc": 6.91,
    "disb": 2.58,
    "bal": 4.33,
    "finBal": 4.33,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "2026-74264",
    "req": "G-2026-74264",
    "status": "Active",
    "theme": "Health",
    "grantee": "Direct Implementation",
    "title": "Model UPHC project Nagpur",
    "start": "01-Oct-2017",
    "end": "31-Oct-2021",
    "sanc": 10.5,
    "disb": 6.47,
    "bal": 4.03,
    "finBal": 4.03,
    "catg": "Not found in FIN Commitment-Active and Balance available in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70036",
    "req": "G-70036",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "Collectives for Integrated Livelihood Initiatives",
    "title": "Parivartan - Lakhpati Kisan Program -Gujarat",
    "start": "01-Apr-2022",
    "end": "31-Mar-2024",
    "sanc": 8.33,
    "disb": 5.18,
    "bal": 3.15,
    "finBal": 3.15,
    "catg": "Closed-Not found in FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70034",
    "req": "G-70034",
    "status": "Under Closure",
    "theme": "Health",
    "grantee": "Collectives for Integrated Livelihood Initiatives",
    "title": "Madhya Pradesh Health System Strengthening Program",
    "start": "01-Jan-2021",
    "end": "30-Jun-2025",
    "sanc": 23.96,
    "disb": 21.2,
    "bal": 2.76,
    "finBal": 2.76,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TSWT",
    "id": "70175",
    "req": "G-70175",
    "status": "Active",
    "theme": "Cancer Care",
    "grantee": "Tata Memorial Centre",
    "title": "Patient Navigation - Kevat Program Phase 2",
    "start": "01-Nov-2021",
    "end": "31-Jul-2026",
    "sanc": 7.61,
    "disb": 4.95,
    "bal": 2.66,
    "finBal": 2.66,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70086",
    "req": "G-70086",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Foundation for Ecological Security",
    "title": "Shared Natural Resource Systems for Sustainable Livelihoods",
    "start": "01-Apr-2019",
    "end": "30-Sep-2025",
    "sanc": 36.5,
    "disb": 34.54,
    "bal": 1.96,
    "finBal": 1.96,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "2025-70217",
    "req": "G-2025-70217",
    "status": "Under Closure",
    "theme": "Health",
    "grantee": "Vijayavahini Charitable Foundation",
    "title": "Strengthening Primary Healthcare Through Participatory Action Research in a Tribal District of North Telangana",
    "start": "01-Mar-2024",
    "end": "31-Mar-2026",
    "sanc": 9.53,
    "disb": 8.21,
    "bal": 1.32,
    "finBal": 1.32,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70087",
    "req": "G-70087",
    "status": "Active",
    "theme": "Building Institutions",
    "grantee": "Foundation for Innovation & Social Enterpreneurship",
    "title": "Mach33.aero",
    "start": "01-Jun-2017",
    "end": "30-Sep-2026",
    "sanc": 14.0,
    "disb": 13.08,
    "bal": 0.92,
    "finBal": 0.92,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70085",
    "req": "G-70085",
    "status": "Active",
    "theme": "Health",
    "grantee": "Forum for Health Systems Design and Transformation",
    "title": "Technical Support to Ministry of Health and Family Welfare, (Government of India) for 'National Programme for Non-Communicable Diseases (NP-NCD).",
    "start": "01-Sep-2023",
    "end": "31-Dec-2025",
    "sanc": 10.16,
    "disb": 9.27,
    "bal": 0.89,
    "finBal": 0.89,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "70096",
    "req": "G-70096",
    "status": "Under Closure",
    "theme": "Education",
    "grantee": "Himmotthan Society",
    "title": "Phase 2 of Education Initiative in 3 Districts in Uttarakhand",
    "start": "01-Oct-2022",
    "end": "31-Mar-2026",
    "sanc": 8.25,
    "disb": 7.37,
    "bal": 0.87,
    "finBal": 0.87,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "2026-74442",
    "req": "G-2026-74442",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Direct Implementation",
    "title": "DI-Small Holder Poultry Project in Yavatmal District in Vidarbha under SBI",
    "start": "01-Apr-2018",
    "end": "30-Jun-2023",
    "sanc": 3.72,
    "disb": 2.85,
    "bal": 0.87,
    "finBal": 0.87,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70070",
    "req": "G-70070",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "Direct Implementation",
    "title": "Textile Design & Research component of Antaran",
    "start": "01-Jul-2020",
    "end": "31-Jul-2024",
    "sanc": 1.66,
    "disb": 0.79,
    "bal": 0.87,
    "finBal": 0.87,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TSWT",
    "id": "70143",
    "req": "G-70143",
    "status": "Under Closure",
    "theme": "Health",
    "grantee": "Sri Aurobindo Society",
    "title": "Sanjeevan – An integral approach to end of life care",
    "start": "17-Mar-2020",
    "end": "30-Sep-2025",
    "sanc": 4.02,
    "disb": 3.21,
    "bal": 0.82,
    "finBal": 0.82,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70109",
    "req": "G-70109",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Kalike",
    "title": "Climate Smart Agriculture (CSA) Program in Yadgir, an Aspirational district of Karnataka",
    "start": "01-Jul-2022",
    "end": "31-Dec-2025",
    "sanc": 5.03,
    "disb": 4.4,
    "bal": 0.63,
    "finBal": 0.63,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70126",
    "req": "G-70126",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "North East Initiative Development Agency",
    "title": "Phase 2 of Integrated Livelihood Project in Arunachal Pradesh, Mizoram and Nagaland: Climate Smart Agriculture and Livestock (CSAL)[1] in North East India - Nagaland",
    "start": "01-Jul-2022",
    "end": "31-Dec-2025",
    "sanc": 7.15,
    "disb": 6.53,
    "bal": 0.62,
    "finBal": 0.62,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70069",
    "req": "G-70069",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "Direct Implementation",
    "title": "Small Holder Poultry project in SBI (Government Fund Contribution)",
    "start": "02-Aug-2018",
    "end": "30-Jun-2023",
    "sanc": 13.34,
    "disb": 12.84,
    "bal": 0.49,
    "finBal": 0.49,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70071",
    "req": "G-70071",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "Direct Implementation",
    "title": "Textile Design & Research component of Antaran",
    "start": "01-Jul-2020",
    "end": "31-Jul-2024",
    "sanc": 1.76,
    "disb": 1.34,
    "bal": 0.42,
    "finBal": 0.42,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "2026-73494",
    "req": "G-2026-73494",
    "status": "Active",
    "theme": "Health",
    "grantee": "Direct Implementation",
    "title": "Repair works at Sheth M C Damanwala Dispensary in Udvada",
    "start": "01-Apr-2025",
    "end": "30-Jun-2026",
    "sanc": 2.2,
    "disb": 1.86,
    "bal": 0.34,
    "finBal": 0.34,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70139",
    "req": "G-70139",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "Reviving Green Revolution Cell",
    "title": "Integrated Drinking Water Project in Punjab",
    "start": "01-Jun-2021",
    "end": "31-Dec-2023",
    "sanc": 1.25,
    "disb": 0.91,
    "bal": 0.34,
    "finBal": 0.34,
    "catg": "Closed-Not found in FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "JTT",
    "id": "2025-72911",
    "req": "G-2025-72911",
    "status": "Active",
    "theme": "Building Institutions",
    "grantee": "Indian Institute of Science",
    "title": "Supporting International Ph.D. Students",
    "start": "01-Mar-2019",
    "end": "31-Mar-2026",
    "sanc": 1.05,
    "disb": 0.74,
    "bal": 0.31,
    "finBal": 0.31,
    "catg": "Not found in FIN Commitment-Active and Balance available in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70187",
    "req": "G-70187",
    "status": "Under Closure",
    "theme": "Nutrition",
    "grantee": "Vijayavahini Charitable Foundation",
    "title": "YES To POSHAN in partnership with Asian Paints.",
    "start": "01-Jan-2022",
    "end": "31-Dec-2024",
    "sanc": 0.79,
    "disb": 0.53,
    "bal": 0.26,
    "finBal": 0.26,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70021",
    "req": "G-70021",
    "status": "Under Closure",
    "theme": "Education",
    "grantee": "Centre for Microfinance and Livelihoods",
    "title": "Technology Based School Interventions (TBSI) in Assam – Phase II",
    "start": "01-Nov-2021",
    "end": "31-Mar-2025",
    "sanc": 3.78,
    "disb": 3.52,
    "bal": 0.25,
    "finBal": 0.25,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70079",
    "req": "G-70079",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "Direct Implementation",
    "title": "Phase 2 of Gender Empowerment through Integrated Menstrual Hygiene Management (MHM) Initiative in Uttar Pradesh",
    "start": "01-Aug-2022",
    "end": "30-Apr-2026",
    "sanc": 1.8,
    "disb": 1.57,
    "bal": 0.23,
    "finBal": 0.23,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70135",
    "req": "G-70135",
    "status": "Under Closure",
    "theme": "Building Institutions",
    "grantee": "Pune International Centre",
    "title": "Setting up of an Incubation Centre for Social Innovation in the Campus of the proposed Pune International Centre",
    "start": "01-Jul-2022",
    "end": "30-Jun-2025",
    "sanc": 15.0,
    "disb": 14.89,
    "bal": 0.11,
    "finBal": 0.11,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TET",
    "id": "70171",
    "req": "G-70171",
    "status": "Under Closure",
    "theme": "Health",
    "grantee": "Tata Institute of Social Sciences",
    "title": "Koshish-A filed action project on Homelessness and destitution",
    "start": "01-Oct-2018",
    "end": "31-Jan-2025",
    "sanc": 2.99,
    "disb": 2.9,
    "bal": 0.09,
    "finBal": 0.09,
    "catg": "Closed-Not found in FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "70185",
    "req": "G-70185",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Vijayavahini Charitable Foundation",
    "title": "Maa Thota (TDF)-Lakshadhikari Rythu Convergence",
    "start": "01-Jun-2018",
    "end": "31-Mar-2026",
    "sanc": 2.0,
    "disb": 1.91,
    "bal": 0.09,
    "finBal": 0.09,
    "catg": "Not found in FIN Commitment-Active and Balance available in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "2025-70248",
    "req": "G-2025-70248",
    "status": "Active",
    "theme": "Health",
    "grantee": "Jan Swasthya Sahayog",
    "title": "Improving Access to Comprehensive Primary Healthcare (CPHC) in Tribal Region of Chhattisgarh, Madhya Pradesh",
    "start": "01-Apr-2024",
    "end": "31-Mar-2026",
    "sanc": 9.36,
    "disb": 9.28,
    "bal": 0.08,
    "finBal": 0.08,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70127",
    "req": "G-70127",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "North East Initiative Development Agency",
    "title": "Water Security Programme: Tata Water Mission - 2022-27 - Mizoram",
    "start": "01-Oct-2022",
    "end": "31-Dec-2025",
    "sanc": 3.48,
    "disb": 3.4,
    "bal": 0.08,
    "finBal": 0.08,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70094",
    "req": "G-70094",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Himmotthan Society",
    "title": "Central Himalayan Livestock Initiative (CHLI) - Phase 2",
    "start": "01-Jan-2022",
    "end": "30-Jun-2026",
    "sanc": 13.95,
    "disb": 13.87,
    "bal": 0.08,
    "finBal": 0.08,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70115",
    "req": "G-70115",
    "status": "Active",
    "theme": "Education",
    "grantee": "Karta Initiative India Foundation",
    "title": "Period Extension and Grant to section 8 for The Karta Initiative",
    "start": "01-Jun-2022",
    "end": "30-Jun-2026",
    "sanc": 9.14,
    "disb": 9.07,
    "bal": 0.07,
    "finBal": 0.07,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "70052",
    "req": "G-70052",
    "status": "Active",
    "theme": "Education",
    "grantee": "Collectives for Integrated Livelihood Initiatives",
    "title": "Phase 2 of Education Initiative in 11 districts of Jharkhand and Odisha",
    "start": "01-Sep-2022",
    "end": "30-Jun-2026",
    "sanc": 27.16,
    "disb": 27.1,
    "bal": 0.06,
    "finBal": 0.06,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70124",
    "req": "G-70124",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "North East Initiative Development Agency",
    "title": "Phase 2 of Integrated Livelihood Project in Mizoram: Climate Smart Agriculture and Livestock (CSAL) in North East India",
    "start": "01-Jul-2022",
    "end": "31-Dec-2025",
    "sanc": 6.4,
    "disb": 6.35,
    "bal": 0.05,
    "finBal": 0.05,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70033",
    "req": "G-70033",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "Collectives for Integrated Livelihood Initiatives",
    "title": "Agriculture Entrepreneurship Programme",
    "start": "01-Dec-2019",
    "end": "30-Nov-2022",
    "sanc": 9.76,
    "disb": 9.71,
    "bal": 0.04,
    "finBal": 0.04,
    "catg": "Closed-Not found in FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70125",
    "req": "G-70125",
    "status": "Under Closure",
    "theme": "Rural Upliftment",
    "grantee": "North East Initiative Development Agency",
    "title": "Phase 2 of Integrated Livelihood Project in Arunachal Pradesh, Mizoram and Nagaland: Climate Smart Agriculture and Livestock (CSAL)[1] in North East India - Arunachal Pradesh",
    "start": "01-Jul-2022",
    "end": "31-Dec-2025",
    "sanc": 2.68,
    "disb": 2.65,
    "bal": 0.03,
    "finBal": 0.03,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70103",
    "req": "G-70103",
    "status": "Closed",
    "theme": "Education",
    "grantee": "Impact Foundation India",
    "title": "Leveraging talent for growth",
    "start": "01-Dec-2018",
    "end": "30-Nov-2021",
    "sanc": 2.75,
    "disb": 2.72,
    "bal": 0.03,
    "finBal": 0.03,
    "catg": "Closed-Not found in FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "2025-70216",
    "req": "G-2025-70216",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "The Tata Agricultural And Rural Training Centre For The Blind (TACEB)",
    "title": "Institutional Support to The Tata Agricultural and Rural Training Centre for the Blind (TACEB) at Phansa in Gujarat",
    "start": "01-Apr-2024",
    "end": "31-Mar-2027",
    "sanc": 5.0,
    "disb": 4.97,
    "bal": 0.03,
    "finBal": 0.03,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70058",
    "req": "G-70058",
    "status": "Active",
    "theme": "Water and Sanitation",
    "grantee": "Collectives for Integrated Livelihood Initiatives",
    "title": "Phase 2 of Gender Empowerment through Integrated Menstrual Hygiene Management (MHM) Initiative in Gujarat",
    "start": "01-Aug-2022",
    "end": "30-Jun-2026",
    "sanc": 1.87,
    "disb": 1.85,
    "bal": 0.02,
    "finBal": 0.02,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70155",
    "req": "G-70155",
    "status": "Active",
    "theme": "Cancer Care",
    "grantee": "Tata Cancer Care Foundation",
    "title": "Ranchi cancer Hospital",
    "start": "01-Aug-2021",
    "end": "31-Mar-2025",
    "sanc": 83.15,
    "disb": 83.13,
    "bal": 0.02,
    "finBal": 0.02,
    "catg": "Closed as per FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "JRD Tata",
    "id": "70178",
    "req": "G-70178",
    "status": "Closed",
    "theme": "Cancer Care",
    "grantee": "The Jimmy S Bilimoria Foundation",
    "title": "Supporting PALCARE’s Home-Based Service in Greater Mumbai",
    "start": "01-Apr-2023",
    "end": "30-Sep-2025",
    "sanc": 1.56,
    "disb": 1.54,
    "bal": 0.02,
    "finBal": 0.02,
    "catg": "Closed-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70014",
    "req": "G-70014",
    "status": "Closed",
    "theme": "Education",
    "grantee": "CENTRE FOR MICROFINANCE",
    "title": "Phase 2 of Education Initiative in Sirohi and Karauli districts in Rajasthan",
    "start": "01-Nov-2022",
    "end": "31-Dec-2025",
    "sanc": 7.41,
    "disb": 7.39,
    "bal": 0.02,
    "finBal": 0.02,
    "catg": "Closed-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70117",
    "req": "G-70117",
    "status": "Under Closure",
    "theme": "Education",
    "grantee": "Language and Learning Foundation",
    "title": "Phase 3 of Education Initiative in Shrawasti district in Uttar Pradesh",
    "start": "01-Sep-2022",
    "end": "31-Aug-2025",
    "sanc": 4.2,
    "disb": 4.19,
    "bal": 0.01,
    "finBal": 0.01,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70022",
    "req": "G-70022",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "Centre for Microfinance and Livelihoods",
    "title": "Phase 2 of Gender Empowerment through Integrated Menstrual Hygiene Management (MHM) Initiative in Assam",
    "start": "01-Aug-2022",
    "end": "31-Mar-2026",
    "sanc": 1.42,
    "disb": 1.41,
    "bal": 0.01,
    "finBal": 0.01,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SDTT",
    "id": "2025-72926",
    "req": "G-2025-72926",
    "status": "Under Closure",
    "theme": "Arts, Culture and Creative Economies",
    "grantee": "Archival and Research Project (ARPO)",
    "title": "Earthlore Fellowship Program",
    "start": "01-Jan-2025",
    "end": "31-Dec-2025",
    "sanc": 0.94,
    "disb": 0.93,
    "bal": 0.01,
    "finBal": 0.01,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70189",
    "req": "G-70189",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "Vijayavahini Charitable Foundation",
    "title": "Phase 2 of Gender Empowerment through Integrated Menstrual Hygiene Management (MHM) Initiative in Andhra Pradesh",
    "start": "01-Aug-2022",
    "end": "31-Mar-2025",
    "sanc": 0.56,
    "disb": 0.55,
    "bal": 0.01,
    "finBal": 0.01,
    "catg": "Closed-Not found in FIN Commitment-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70128",
    "req": "G-70128",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "North East Initiative Development Agency",
    "title": "Water Security Programme: Tata Water Mission - 2022-27 - Arunachal Pradesh",
    "start": "01-Oct-2022",
    "end": "31-Dec-2025",
    "sanc": 2.74,
    "disb": 2.74,
    "bal": 0.0,
    "finBal": 0.0,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70116",
    "req": "G-70116",
    "status": "Active",
    "theme": "Education",
    "grantee": "Khan Academy India",
    "title": "Khan Academy India – Expanding Reach and Piloting Innovation",
    "start": "01-Apr-2024",
    "end": "31-Mar-2026",
    "sanc": 3.8,
    "disb": 3.8,
    "bal": 0.0,
    "finBal": 0.0,
    "catg": "Commitment reduced in FIN Commitment but not changed in Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70129",
    "req": "G-70129",
    "status": "Under Closure",
    "theme": "Water and Sanitation",
    "grantee": "North East Initiative Development Agency",
    "title": "Water Security Programme: Tata Water Mission - 2022-27 - Nagaland",
    "start": "01-Oct-2022",
    "end": "31-Dec-2025",
    "sanc": 5.48,
    "disb": 5.48,
    "bal": 0.0,
    "finBal": 0.0,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "TEDT",
    "id": "70136",
    "req": "G-70136",
    "status": "Under Closure",
    "theme": "Building Institutions",
    "grantee": "Pune International Centre",
    "title": "Setting up the campus of Pune International Centre (PIC) -Towards extension of PICs research programmes -Centre Activity Program",
    "start": "01-Nov-2018",
    "end": "30-Jun-2025",
    "sanc": 5.0,
    "disb": 5.0,
    "bal": 0.0,
    "finBal": 0.0,
    "catg": "Under Closure-Balance to be removed from Fluxx"
  },
  {
    "trust": "SRTT",
    "id": "70065",
    "req": "G-70065",
    "status": "Active",
    "theme": "Rural Upliftment",
    "grantee": "Direct Implementation",
    "title": "Conservation of Biodiversity and Restoration of the Bombay Port Trust Gardern",
    "start": "12-Oct-2017",
    "end": "30-Apr-2028",
    "sanc": 11.73,
    "disb": 10.03,
    "bal": 1.7,
    "finBal": -0.3,
    "catg": "Balance to be checked-DI Case-BPT Project"
  }
];
